<template>
  <div class="purchase-info">
    <div class="purchase-info-head">
      {{ titleTxt(orderDetail.status) }}
    </div>
    <div class="purchase-info-body">
      <div v-if="orderDetail.needToImprove" class="improve-tip-body">
        <img
          class="tip-icon"
          src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20240306100637794-icon_info_fill.png"
          alt=""
        />
        <p class="tip-text">购买信息待补充</p>
        <p class="tip-text">使用APP完善订单购买信息，加快销售配车</p>
      </div>
      <div v-else class="purchase-info-list">
        <div
          class="purchase-info-item"
          v-for="(item, index) in newInfoList"
          :key="index"
        >
          <span class="purchase-info-label">{{ item.label }}</span>
          <span class="purchase-info-value">{{ item.value }}</span>
        </div>
      </div>
      <div
        class="purchase-info-btns"
        v-if="showBtns(orderDetail.status) === 'true'"
      >
        <div class="purchase-info-btn" @click="toOption()">立即定购</div>
        <div class="purchase-info-btn white" @click="toCarType()">
          探索 {{ orderDetail.carSeriesName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isPersonEnu } from "./constant";
export default {
  components: {},
  props: {
    orderDetail: {
      type: Object,
    },
  },
  watch: {
    orderDetail: {
      handler(newValue) {
        console.log("isPerson", newValue.isPerson);
        if (newValue.isPerson === 1) {
          //个人
          this.bothInfoList = [...this.infoList, ...this.person];
        }
        if (newValue.isPerson === 2) {
          //企业
          this.bothInfoList = [...this.infoList, ...this.enterprise];
        }
        this.handleInfoList(newValue);
      },
      deep: true,
    },
  },
  data() {
    return {
      infoList: [
        { label: "购买类型", key: "isPerson" },
        { label: "所在城市", key: "addr" },
        { label: "服务门店", key: "offlineExperienceShopName" },
      ],
      person: [
        { label: "车主姓名", key: "carUsername" },
        { label: "证件类型", key: "carIdentityTypeName" },
        { label: "证件号码", key: "carIdentityNo" },
        { label: "联系电话", key: "carPhone" },
      ],
      enterprise: [
        { label: "企业名称", key: "enterpriseName" },
        { label: "企业信用代码", key: "enterpriseCode" },
        { label: "联系电话", key: "carPhone" },
      ],
      bothInfoList: [],
      newInfoList: [],
    };
  },
  mounted() {},
  created() {},
  methods: {
    handleInfoList(detail) {
      this.newInfoList = this.bothInfoList.map((item) => {
        item.value = detail[item.key];
        if (item.key === "isPerson") {
          item.value = isPersonEnu[item.value];
        }
        return item;
      });
    },
    //跳转选配页
    toOption() {
      window.location.href = `optional.html?type=${this.orderDetail.carSeriesName}`;
    },
    //跳转车型页面
    toCarType() {
      window.location.href = `/usp-${this.orderDetail.carSeriesName.toLowerCase()}.html`;
    },
  },

  computed: {
    titleTxt() {
      return function(status) {
        switch (status) {
          case 8: //已取消
          case 31: //退订中
          case 14: //已退订
            return "重新订购";
          default:
            return "购买信息";
        }
      };
    },
    showBtns() {
      //8、13、14、31
      return function(status) {
        switch (status) {
          case 8: //已取消
          case 13: //待审核
          case 14: //已退款
          case 31: //退订处理中
            return "true";
          default:
            return "false";
        }
      };
    },
  },
};
</script>

<style lang="scss">
@import "@style/base";
@import "@style/common";

.purchase-info {
  overflow: hidden;
  @include media(
    (
      $home-lg: (
        margin-bottom: 40px,
      ),
      $home-bg: (
        padding: 0 20px,
        margin-bottom: 40px,
      ),
      $home-md: (),
      $home-sm: (
        padding: 0,
      ),
    )
  );
}

.purchase-info-head {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  margin-top: 30px;
  margin-bottom: 20px;
}

.purchase-info-body {
  border-radius: 8px;
  background: #fff;

  @include media(
    (
      $md: (
        border: 1px solid #eee,
      ),
      $sm: (
        border: 1px solid #eee,
        padding-top: 15px,
        padding-bottom: 15px,
      ),
    )
  );
}
.improve-tip-body {
  padding: 134px 0;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 8px;
  .tip-icon {
    width: 20px;
    height: 20px;
  }
  .tip-text {
    &:first-of-type {
      margin-top: 10px;
      font-family: PingFang SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      color: #ec5042;
    }
    &:last-of-type {
      font-family: PingFang SC;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #000000;
    }
  }
}
.purchase-info-list {
  border: 1px solid #eee;
  border-radius: 8px;
  @include media(
    (
      $md: (
        border: none,
      ),
      $sm: (
        border: none,
      ),
    )
  );

  .purchase-info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    height: 50px;
    gap: 15px;
    padding: 0 15px;
  }
}

.purchase-info-btns {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 40px;
  @include media(
    (
      $md: (
        margin-top: 30px,
        flex-direction: row-reverse,
        margin-right: 15px,
        margin-left: 15px,
        margin-bottom: 20px,
      ),
      $sm: (
        flex-direction: row-reverse,
        margin-top: 25px,
        margin-bottom: 10px,
      ),
    )
  );

  .purchase-info-btn {
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #131415;
    height: 40px;
    border-radius: 72px;
    box-sizing: border-box;
    cursor: pointer;
    &.white {
      border: 1px solid #ccc;
      color: #000;
      background-color: #fff;
    }

    @include media(
      (
        $md: (
          flex-grow: 1,
        ),
        $sm: (
          flex-grow: 1,
        ),
      )
    );
  }
}
</style>
